<template>
  <!-- Device selection is now handled by AIAssistantDeviceSelectionModal -->

  <!-- Recording in progress state -->
  <div v-if="summaryStatus === 'recording' && !generatingTranscription" class="container-recording">
    <div class="recording-message">
      <h3>Gravação em andamento.</h3>
      <span class="subtitle">Finalize a gravação para ter acesso à transcrição.</span>
      <!-- <w-button label="Abrir modal" @click="openIframeModal" /> -->
    </div>
  </div>

  <!-- FIXED: Show processing message when generatingTranscription is TRUE (not false) -->
  <!-- This is the "classic loading modal" that should appear during processing states -->
  <div v-if="summaryStatus === 'processing' && generatingTranscription" class="container-recording">
    <div class="processing-container">
      <div v-if="false">
        <svg-icon _ngcontent-ng-c3496710171="" name="end" class="ng-star-inserted"><!-- SVG content --></svg-icon>
      </div>
      <div class="processing-content">
        <w-spinner size="large" />
        <div class="recording-message">
          <h3>Gravação Finalizada.</h3>
          <span class="subtitle">Gerando notas com base na transcrição.</span>
        </div>
      </div>
    </div>
  </div>

  <w-toast :toasts="toasts" @dismiss="onToastDismiss" />
</template>

<style scoped lang="scss">
@import "style-variables.scss";

/* Device selection styles have been moved to AIAssistantDeviceSelectionModal.vue */

.container-recording {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}

.processing-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100%;
}

.recording-message {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.recording-message h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--w-text-color-primary);
}

.subtitle {
  font-weight: 300;
  margin: 0;
  color: var(--w-text-color-secondary);
}

.processing-container {
  justify-content: center;
  text-align: center;
  flex-direction: column;
  display: flex;
  height: 150px;
  align-items: center;
}
</style>

<script setup lang="ts">
/**
 * AIAssistantStartTranscription.vue - Recording/Processing Status Display
 *
 * This component now only displays:
 * - "Recording in progress" message when summaryStatus === 'recording'
 * - "Processing" message when summaryStatus === 'processing' and generating
 *
 * Device selection has been moved to AIAssistantDeviceSelectionModal.vue
 */
import { ref } from "vue";
import { UserTracking } from "@/utils/UserTracking";

const toasts = ref<any[]>([]);

const onToastDismiss = () => {
  toasts.value = [];
};

const props = defineProps({
  initialContext: Object,
  actionState: String,
  summaryStatus: String,
  generatingTranscription: Boolean,
});

const emit = defineEmits(["update-appointment", "close"]);

// Listen for messages from iframe (microphone permission, etc.)
if (typeof window !== "undefined") {
  window.addEventListener("message", (event) => {
    const sessionId =
      (props.initialContext as { recorderSessionId?: string } | undefined)?.recorderSessionId ?? "unknown";

    if (event.data && event.data.type === "MICROPHONE_PERMISSION_DENIED") {
      UserTracking.trackEvent("noa_recorder_mic_permission_denied", {
        session_id: sessionId,
        reason: event.data.reason ?? "unknown",
        source: "start_transcription",
        page_url: window.location.href,
      });
      toasts.value.push({
        leadingIcon: "warning",
        content: "Permissão do microfone negada. A transcrição não funcionará.",
        variant: "error",
        timeOut: 5000,
      });
    } else if (event.data && event.data.type === "IFRAME_LOADED") {
      UserTracking.trackEvent("noa_recorder_iframe_loaded", {
        session_id: sessionId,
        source: "start_transcription",
        page_url: window.location.href,
      });
      console.log("Noa recorder iframe loaded successfully");
    } else if (event.data && event.data.type === "PERMISSION_ERROR") {
      console.error("Permission error from iframe:", event.data.error);
      UserTracking.trackEvent("noa_recorder_permission_error", {
        session_id: sessionId,
        error_message: String(event.data.error ?? "unknown"),
        page_url: window.location.href,
      });
      toasts.value.push({
        leadingIcon: "warning",
        content: `Erro de permissão: ${event.data.error}`,
        variant: "error",
        timeOut: 5000,
      });
    }
  });
}
</script>
